import { Link } from 'react-router-dom';
import { productPagePath } from '../lib/products.js';

/**
 * A small "Product" link to a SKU's product page (its child ASIN, or the SKU
 * itself when it has no ASIN), for table rows that name a product. It stops the
 * click from reaching the row, whose own click opens the SKU.
 */
export function ProductPageLink({ asin, skuId }: { asin: string | null; skuId: number }) {
  return (
    <Link
      to={productPagePath({ asin, skuId })}
      onClick={(e) => e.stopPropagation()}
      className="shrink-0 text-xs text-brand-600 hover:underline"
      title="Open the product page: every SKU on this ASIN in one place"
    >
      Product
    </Link>
  );
}
